import React, { useEffect, useState, useCallback } from "react";
import { Skeleton, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import api from "../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { use } from "react";
import SaveIcon from "../../../src/assets/orders/Save.svg";
import { addIcon, heartIcon, starIcon } from "./svg";
import { setConfig } from "../../reduxtoolkit/userconfigslice";
import { OrderIcons } from "../OrderCards";
import dayjs from "dayjs";
import { getPracticeId } from "../../config/practice";
import { resolveOrderDate } from "../../utils/orderdate";

const ProceduresNavButtons = ({
  data,
  userdata,
  getordersData,
  selectedCard,
  dt,
  loading,
  fetchsuggestions,
  selectedSuggestionList,
    startDate,
  appointmentId,
}) => {
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [selectedAddTabs, setSelectedAddTabs] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedSuggestion, setSelectedSuggestion] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selectedDx, setSelectedDx] = useState("");
  const [selecteddesc, setSelecteddesc] = useState("");
  const [fetcheddata, setFetcheddata] = useState([]);
  const practiseid = getPracticeId();
  const dispatch=useDispatch()
 const userConfig = useSelector((state) => state.userconfig);
  const [fetchingDx, setFetchingDx] = useState(false);
  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
let fav=userConfig.config?.fav_procedures||[]
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const [searchResults, setSearchResults] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const appointmentInfo = useSelector((state) => state.appinfo.appointmentInfo);
  const RelatedResults = useSelector(
    (state) => state.universalsearcher.searchResults
  );
  useEffect(() => {
    if (
      !Array.isArray(selectedSuggestionList) ||
      selectedSuggestionList.length === 0
    ) {
      setSelectedTabs([]);
      return;
    }

    const selectedIndexes = data
      .map((item, index) =>
        selectedSuggestionList.some(
          (suggestion) => suggestion.ordername === item.content
        )
          ? item.content
          : null
      )
      .filter((index) => index !== null);

    setSelectedTabs(selectedIndexes);
  }, [data, selectedSuggestionList]);

  const handleTabClick = async (itemContent) => {
    const isSelected = selectedTabs.includes(itemContent);

    try {
      if (isSelected) {
        // Call delete API
        const orderToDelete = selectedSuggestionList.find(
          (x) => x.ordername === itemContent
        );

        if (orderToDelete) {
          const deleteResponse = await api.delete(
            `/v1/${practiseid}/orders/delete/order/${orderToDelete.ordre_id}`,
            {
              data: {
                // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
                // the date this tab's list was loaded for (never today's fallback: the server
                // picks orders_master or its history table from it, and their ids collide)
                orderdate: resolveOrderDate(dt),
                // scopes the delete to this patient where the server supports it
                ...(userdata?.patientid ? { patientid: Number(userdata.patientid) } : {}),
              },
            }
          );
          console.log("Delete API Response:", deleteResponse.data);
        } else {
          console.error("Order ID not found for deletion");
        }
      } else {
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${userdata.patientid}/orders/create`,
          {
            department_id: 1,
            patient_name: `${userdata.firstname || ""} ${
              userdata.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: userdata.lov,
            diagnosis: "",
            ordertype: "procedure", // tabs
            ordername: itemContent, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: userdata.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
                orderdate:
                    dayjs(dt).isValid()
                      ? dayjs(dt).format("YYYY-MM-DD")
                      : dayjs().format("YYYY-MM-DD"),
            encounterid: 0,
          }
        );
      }

      // Update state after the API call
      setSelectedTabs((prevSelected) => {
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((content) => content !== itemContent);
        } else {
          // Select if not already selected
          return [...prevSelected, itemContent];
        }
      });
      fetchsuggestions();
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const fetchInitialData = async () => {
    setFetchingDx(true);
    try {
      const response = await api.post(`/v1/${practiseid}/orders/get/lcptdata`, {
        ordername: "ECHO",
        patientid: appointmentInfo.patientid,
        appointment_id: appointmentInfo.appointmentid,
      });
      setFetcheddata(response.lcpts || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setFetchingDx(false);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchInitialData();
    }
  }, [isModalOpen]);
const updateFavLabs = async (lab) => {
  try {
    let updatedFavs = [...fav];
    if (!updatedFavs.includes(lab)) {
      updatedFavs.push(lab);
    }

   const response= await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_procedures: updatedFavs,
    });
 if (response.status === 200) {
      // Update Redux state with the new config
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
         fav_procedures: updatedFavs,
        },
      }));
    }
    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error updating fav labs:", error);
  }
};
const removeFavbutton = async (lab) => {
  try {
    // Create a new array without the lab to remove
    const updatedFavs = fav.filter((l) => l !== lab);

    // Update the server
    const response = await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_procedures: updatedFavs,
    });

    if (response.status === 200) {
      // Update Redux state
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
          fav_procedures: updatedFavs,
        },
      }));
    }

    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error removing fav lab:", error);
  }
};
const handlebuttonclick = async (x) => {
  if (isLoading) return; // Prevent multiple clicks
  isLoading = true;

  try {
    const contentToAdd = x; // Assuming it's a string

    if (!selectedTabs.includes(contentToAdd) &&
        !selectedSuggestionList.some((item) => item.ordername === contentToAdd)) {
      await handleTabClick(contentToAdd);
      selectedTabs.push(contentToAdd);
    }
  } catch (error) {
    console.error("Error in handleStrepFluCovidClick:", error);
  } finally {
    isLoading = false;
  }
};
  const fetchMedicationSuggestions = useCallback(
    debounce(async () => {
      if (inputValue.trim().length > 1) {
        try {
          const response = await api.post(
            `/v1/${practiseid}/orders/patient/${appointmentInfo.patientid}/get/searchlcddiagnostics`,
            {
              searchVal: inputValue,
              patientId: appointmentInfo.patientid,
              order_name: modalContent.content,
              limit: 5,
            }
          );
          if (response.status === 200) {
            setSearchResults(response.data);
          }
        } catch (error) {
          console.error("Error fetching suggestions:", error);
        }
      }
    }, 300),
    [inputValue]
  );

  useEffect(() => {
    fetchMedicationSuggestions();
    return () => fetchMedicationSuggestions.cancel();
  }, [inputValue, fetchMedicationSuggestions]);

  const submit = async () => {
    setIsSubmitting(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/patient/${appointmentInfo.patientid}/orders/lcpt-procedure/insert`,
        {
          // icd_sugg: selectedDx,

          patient_id: appointmentInfo.patientid,
          patient_name: `${appointmentInfo.firstname || ""} ${
            appointmentInfo.lastname || ""
          }`.trim(),
          order_id: modalContent.id,
          autosel: "todayList",
          tov: tovValue,
          lov: lovValue,
          diagnosis: selecteddesc,
          ordertype: "procedure",
          ordername: modalContent.content,
          snomed_icd: selectedDx,
          schedule: selectedCard,
          provider: appointmentInfo?.providername,
          status: "CREATED",
          confirm_status: "E",
          user_role: "",
          orderdate:
            dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
              ? dt.split(" ")[0]
              : new Date().toISOString().split("T")[0],
          encounterid: 0,
          department_id: appointmentInfo?.departmentid,
        }
      );
      if (response.status === 200) {
        fetchsuggestions();
        setIsModalOpen(false); // Close the modal on success
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTabClickInhouse = async (itemContent) => {
    const isSelected = selectedTabs.includes(itemContent);
    const orderType = ["STREP TEST", "FLU TEST", "COVID TEST"].includes(
      itemContent
    )
      ? "Diagnostic test"
      : "labs";
    try {
      if (isSelected) {
        // Call delete API
        const orderToDelete = RelatedResults.find(
          (x) => x.ordername === itemContent
        );
        if (orderToDelete) {
          const deleteResponse = await api.delete(
            `/v1/${practiseid}/orders/delete/order/${orderToDelete.ordre_id}`,
            {
              data: {
                // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
                orderdate:
                  dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                    ? dt.split(" ")[0]
                    : new Date().toISOString().split("T")[0],
              },
            }
          );
          console.log("Delete API Response:", deleteResponse.data);
        } else {
          console.error("Order ID not found for deletion");
        }
      } else {
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${userdata.patientid}/orders/create`,
          {
            department_id: 1,
            patient_name: `${userdata.firstname || ""} ${
              userdata.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: userdata.lov,
            diagnosis: "",
            ordertype: orderType, // tabs
            ordername: itemContent, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: userdata.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:
              dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                ? dt.split(" ")[0]
                : new Date().toISOString().split("T")[0],
            encounterid: 0,
          }
        );
      }

      // Update state after the API call
      setSelectedTabs((prevSelected) => {
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((content) => content !== itemContent);
        } else {
          // Select if not already selected
          return [...prevSelected, itemContent];
        }
      });
      fetchsuggestions();
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  let isLoadingInHouseLabs = false; // This will track whether the function is already running
   const inHouseLabsContent = [
      "CBC",
      "A1C",
      "CMP",
      "LIPIDS",
      "MAGNESIUM",
      "URIC ACID",
      "THYROID PANEL",
      "VIT D",
      "VIT B12",
      "TESTO",
    ];
  const handleInHouseLabsClick = async () => {
    if (isLoadingInHouseLabs) return; // Prevent double-clicking if already loading
    isLoadingInHouseLabs = true; // Set loading to true to prevent further invocations

 
    try {
      // Filter out the items that are already in selectedTabs
      const itemsToAdd = inHouseLabsContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !getordersData?.look.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs in parallel
        await Promise.all(
          itemsToAdd.map((content) => handleTabClickInhouse(content))
        );

        // Update selectedTabs with the newly added items
        selectedTabs.push(...itemsToAdd);
      }
    } catch (error) {
      console.error("Error in handleInHouseLabsClick:", error);
    } finally {
      isLoadingInHouseLabs = false; // Reset the loading state after the operation is complete
    }
  };

  let isLoading = false; // This will track whether the function is already running
 const stripfluContent = ["STREP TEST", "FLU TEST", "COVID TEST"];

  const handleStrepFluCovidClick = async () => {
    if (isLoading) return; // Prevent double-clicking if already loading
    isLoading = true; // Set loading to true to prevent further invocations

   
    try {
      // First, filter out the items that are already in selectedTabs or selectedSuggestionList
      const itemsToAdd = stripfluContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !getordersData?.look.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs or selectedSuggestionList in parallel
        await Promise.all(
          itemsToAdd.map((content) => handleTabClickInhouse(content))
        );
      }
    } catch (error) {
      console.error("Error in handleStrepFluCovidClick:", error);
    } finally {
      isLoading = false; // Reset the loading state after the operation is complete
    }
  };

  return (
    <div className="bmor">
      <div className="bmor-section">
        <span className="bmor-section-title">
          <span style={{ width: 14, height: 14, color: "#e0a422", display: "inline-flex" }}>{OrderIcons.star}</span>
          Favourites
        </span>
        <span className="bmor-section-hint">Your saved procedures</span>
      </div>
      <div className="bmor-chips">
        {fav.map((lab) => {
          const isSelected = selectedTabs.includes(lab);

          return (
            <button
              key={lab}
              type="button"
              className={`bmor-chip${isSelected ? " on" : ""}`}
              onClick={() => handlebuttonclick(lab)}
            >
              {isSelected ? OrderIcons.check : OrderIcons.plus}
              {lab}
              <span
                className="bmor-chip-x"
                role="button"
                title="Remove from favourites"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent parent click
                  removeFavbutton(lab);
                }}
              >
                ×
              </span>
            </button>
          );
        })}
        <button
          type="button"
          className="bmor-chip ghost"
          aria-expanded={!!selectedAddTabs}
          onClick={() => setSelectedAddTabs((prev) => !prev)}
        >
          {selectedAddTabs ? "Done" : <>{OrderIcons.plus}Add favourite</>}
        </button>
      </div>
      {!!selectedAddTabs && (
        <div className="bmor-chips" style={{ marginTop: 10 }}>
          {data
            .filter(
              (x) =>
                x.content !== "INHOUSE LABS-MALE" &&
                x.content !== "INHOUSE LABS-FEMALE" &&
                !fav.includes(x.content)
            )
            .map((item) => (
              <button
                key={item.content}
                type="button"
                className="bmor-chip"
                onClick={() => updateFavLabs(item.content)}
              >
                <span style={{ color: "#d0533f", display: "inline-flex" }}>{OrderIcons.heart}</span>
                {item.content}
              </button>
            ))}
        </div>
      )}

      <div className="bmor-section">
        <span className="bmor-section-title">
          <span className="bmor-section-dot" style={{ background: "#4f5bd5" }} />
          Procedures
        </span>
        <span className="bmor-section-hint">Select to add, select again to remove</span>
      </div>
      {loading ? (
        <div className="bmor-skel">
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" width={120} height={42} style={{ borderRadius: 999 }} />
          ))}
        </div>
      ) : data.length > 0 ? (
        <div className="bmor-chips">
          {data.map((item, index) => {
            const isSelected = selectedTabs.includes(item.content);
            return (
              <button
                key={index}
                type="button"
                className={`bmor-chip${isSelected ? " on" : ""}`}
                aria-pressed={isSelected}
                onClick={() => handleTabClick(item.content)}
              >
                {isSelected ? OrderIcons.check : OrderIcons.plus}
                {item.content}
              </button>
            );
          })}
        </div>
      ) : (
        <p className="bmor-empty-line">No suggestions found</p>
      )}

      {/* <Dialog open={isModalOpen} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogContent>
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-medium">{modalContent.content}</h2>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className="relative w-full max-w-md ">
                        <FontAwesomeIcon
                            icon={faSearch}
                            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                        />
                        <input
                            type="text"
                            className="rounded-[15px] w-[100%] border border-[#D5D5D5] bg-[#F5F6FA] pl-10 pr-16 py-1 text-base outline-none"
                            placeholder="Search here"
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue(e.target.value);
                                setIsChecked(false);
                            }}
                        />
                    </div>
                    {searchResults && !isChecked && searchResults.length > 0 && (
                        <ul className="mt-2 w-full border rounded-xl">
                            {searchResults.map((suggestion, index) => (
                                <li
                                    key={index}
                                    onClick={() => {
                                        setInputValue(suggestion.condition_name);
                                        setSelectedDx(suggestion.condition_name);
                                        setSelecteddesc(suggestion.condition_name)
                                        setIsChecked(true);
                                    }}
                                    className="p-2 hover:bg-gray-200 text-xs cursor-pointer"
                                >
                                    {suggestion.condition_name}
                                </li>
                            ))}
                        </ul>
                    )}
                    {fetcheddata.length > 0 && (<>
                    <div className='mt-4 text-sm'>Most Used DX</div>
                        <div className="mt-2 flex flex-wrap gap-2">
                            
                            {fetchingDx ? (
                                Array.from({ length: 3 }).map((_, index) => (
                                    <Skeleton
                                        key={index}
                                        variant="rectangular"
                                        width={100}
                                        height={25}
                                        style={{ margin: '8px', borderRadius: '50px' }}
                                    />
                                ))
                            ) : (
                                fetcheddata.map((item, index) => (
                                    <div
                                        key={index}
                                        onClick={() => {
                                            setInputValue('');
                                            setSelectedDx(item.icd10);
                                            setSelecteddesc(item.description)
                                        }}
                                        className={`cursor-pointer text-xs font-poppins py-2 tracking-tight font-thin text-center rounded-full border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out ${
                                            selectedDx === item.icd10
                                                ? 'bg-[#e17954] text-white'
                                                : 'bg-white text-[#1D2951]'
                                        } px-3 `}
                                        style={{ margin: '1px' }}
                                    >
                                        {item.description}
                                    </div>
                                ))
                            )}
                        </div>
                   </> )}
                    <div className="w-full flex justify-center mt-2">
                        <button
                            onClick={() => submit()}
                            disabled={isSubmitting}
                            className={`rounded py-2 px-12 mt-4 text-sm transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
                                isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-[black] text-[#FFFFFF]'
                            }`}
                        >
                            {isSubmitting ? 'Submitting...' : 'Continue'}
                        </button>
                    </div>
                </DialogContent>
            </Dialog> */}
    </div>
  );
};

// Debounce utility function
function debounce(func, wait) {
  let timeout;
  const debounced = (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
  debounced.cancel = () => clearTimeout(timeout);
  return debounced;
}
export default ProceduresNavButtons;
